@if (showViewer) {
  <app-popup
    [heading]="fileName"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
    [isFullScreen]="true"
    [cancelText]="'Close'"
    (cancelClicked)="onClose()"
  >
    <button
      header-actions
      class="download-action-btn"
      (click)="onDownload()"
      title="Download File"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="12"
        height="12"
        fill="currentColor"
      >
        <path
          d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        />
      </svg>
      Download
    </button>
    <div class="modal-body file-viewer-modal-body">
      <div class="viewer-container">
        @if (isPreviewUnsupported) {
          <div class="viewer-error office-fallback">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="48"
              height="48"
              fill="#64748b"
            >
              <path
                d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
              />
            </svg>
            <p class="preview-title">
              Preview not available for this file type
            </p>
            <p class="preview-description">
              Due to privacy and browser security constraints, Microsoft Office
              documents and raw data files cannot be previewed inline. Please
              download the file to view its contents.
            </p>
            <button
              class="download-action-btn download-btn-spacing"
              (click)="onDownload()"
              title="Download File"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                width="12"
                height="12"
                fill="currentColor"
              >
                <path
                  d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                />
              </svg>
              Download File
            </button>
          </div>
        } @else if (safeFileUrl) {
          <iframe [src]="safeFileUrl" title="File Preview"></iframe>
        }
      </div>
    </div>
  </app-popup>
}
